export default {
    default: 'sl',
};
